export default "__VITE_ASSET__DJEoxOYk__"